import horizontalLogoGreen from '../../media/horizontal-logo-green.svg';
import twitterIconGreyImg from '../../media/social-icons/twitter-icon-grey.svg';
import discordIconGreyImg from '../../media/social-icons/discord-icon-grey.svg';

function Footer() {
    return (
        <footer className="bg-dark-grey text-white pt-18 p-12">
            <div className="w-boxed max-w-full mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-10 md:mb-20">
                    <div className="col-span-1 md:col-span-2">
                        <div className="mb-6">
                            <a href="/"><img src={horizontalLogoGreen} alt="Acre" className="h-7" /></a>
                        </div>
                        <p className="mb-4 md:mb-10 md:max-w-2/3">
                            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.
                        </p>
                        <h5 className="font-bold mb-2 md:mb-4">Follow us</h5>
                        <div className="flex space-x-3">
                            <a className="transition-all hover:scale-105" href="https://twitter.com/Acre_HQ"><img className="w-7" src={twitterIconGreyImg} alt="Join us on Twitter" /></a>
                            <a className="transition-all hover:scale-105" href="https://discord.gg/MXpPqZDrXV"><img className="w-7" src={discordIconGreyImg} alt="Join us on Discord" /></a>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <h5 className="font-bold mb-2 md:mb-5">Resources</h5>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/getting-started">Getting started</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/docs">API Docs</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/platform-status">Platform status</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/help-center">Help center</a></div>
                    </div>
                    <div className="col-span-1">
                    <h5 className="font-bold mb-2 md:mb-5">Property</h5>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/getting-started">Buy</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/docs">Sell</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/platform-status">Rent</a></div>
                    </div>
                    <div className="col-span-1">
                    <h5 className="font-bold mb-2 md:mb-5">Company</h5>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/getting-started">Blog</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/docs">DAO</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/platform-status">Careers</a></div>
                        <div className="mb-1 md:mb-4"><a className="py-1 hover:font-bold hover:tracking-wide" href="/help-center">Privacy Policy</a></div>
                    </div>
                </div>
                <div className="w-full border-b border-b-solid border-b-grey mb-8"></div>
                <div className="w-full flex justify-between items-stretch md:items-center text-sm flex-col md:flex-row">
                    <div className="text-center sm:text-left mb-4 md:mb-0">© Copyright 2022 Acre Software LLC. All Rights Reserved.</div>
                    <div className="flex justify-between md:justify-end items-center space-x-6">
                        <a className="hover:font-bold" href="/privacy-policy">Privacy Policy</a>
                        <a className="hover:font-bold" href="/toc">Terms and Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;